import { Create } from 'react-admin';
import { SettingForm } from './Setting.Form';

export const SettingCreate = () => (
    <Create redirect="list">
        <SettingForm />
    </Create>
);
